// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__gcsOv","faq__sub-heading":"styles_faq__sub-heading__fCUI2"};